import React, { Fragment } from 'react'
import formatPrice, {formatRoundPrice} from '../../../utilities/currency/formatPrice'
import getCombinedTaxesFeesTotal from '../../../utilities/currency/getCombinedTaxesFeesTotal'

import _ from 'lodash'
import yn from 'yn'
import {connect} from "react-redux";

const BkFlowRoomCardTaxesFees = props => {
	const {
		hotelLabels,
		roomRateData,
		activeCurrencyData,
		rateCurrencyCode,
		rateCurrencySymbol,
		urlData
	} = props

	let hotelCode = "";

	if (urlData) {
		hotelCode = urlData.hotelCode;
	}

	let showTaxesBreakdown = true;

	if (hotelCode !== "" && hotelCode === 'B5C3') {
		showTaxesBreakdown = false;
	}

	if (!showTaxesBreakdown) {
		const combinedTaxesFees = getCombinedTaxesFeesTotal(roomRateData)

		return combinedTaxesFees !== null ? (
			<div className="bk-flow-room__price-details-accordion-row total">
				<h6 className="label">{ hotelLabels.roomRateTaxesFeesTitle ? hotelLabels.roomRateTaxesFeesTitle : 'Taxes & Fees' }:</h6>
				<p className="value u-font-bold">{rateCurrencySymbol}{formatPrice(combinedTaxesFees * activeCurrencyData.exchangeRate, 2)} { rateCurrencyCode && <span className="currency">&nbsp;{rateCurrencyCode}</span> }</p>
			</div>
		) : null
	}

	// Init tax total & line items
	let taxesFeesList = []

	if (
		roomRateData &&
		roomRateData.rates &&
		_.get(roomRateData.rates, '[0].total.taxes')
	) {
		const taxesFeesPerNight = _.get(roomRateData, 'rates[0].total.taxes.tax', [])
		const taxesFeesPerStay = _.get(roomRateData, 'rates[0].total.viewExtensions.tax', [])
		let taxesFeesData = process.env.REACT_APP_COMPONENT_ROOM_RATE_TAXES_FEES_FREQUENCY === 'total' && !_.isEmpty(taxesFeesPerStay) ? taxesFeesPerStay : taxesFeesPerNight

		if (!_.isEmpty(taxesFeesData)) {
			for (const taxKey in taxesFeesData) {
				const currentTaxItem = taxesFeesData[taxKey]

				let hasExpenditure = false
				let taxDescription = ''

				if (
					currentTaxItem.percent ||
					currentTaxItem.amount
				) {
					hasExpenditure = true
				}

				if (currentTaxItem.taxDescription) {
					for (const taxDescriptionKey in currentTaxItem.taxDescription) {
						if (
							process.env.REACT_APP_COMPONENT_ROOM_DETAILS_TAXES_FEES_LABELS === 'default' &&
							currentTaxItem.taxDescription[taxDescriptionKey].name &&
							currentTaxItem.taxDescription[taxDescriptionKey].name === 'Name' &&
							currentTaxItem.taxDescription[taxDescriptionKey].text
						) {
							taxDescription = currentTaxItem.taxDescription[taxDescriptionKey].text
						} else if (
							process.env.REACT_APP_COMPONENT_ROOM_DETAILS_TAXES_FEES_LABELS === 'detailed' &&
							currentTaxItem.taxDescription[taxDescriptionKey].name &&
							currentTaxItem.taxDescription[taxDescriptionKey].name === 'Description' &&
							currentTaxItem.taxDescription[taxDescriptionKey].text
						) {
							taxDescription = currentTaxItem.taxDescription[taxDescriptionKey].text
						}
					}
				}

				if (
					hasExpenditure &&
					taxDescription &&
					taxDescription !== ''
				) {
					let renderTaxExpenditure = null
					let renderTaxFrequency = null

					if (currentTaxItem.chargeFrequency) {
						renderTaxFrequency = currentTaxItem.chargeFrequency
					}

					// Construct tax expenditure based on a percent existing or falling back to a dollar amount
					if (currentTaxItem.percent){
						renderTaxExpenditure = (
							<Fragment>
								<span className="tax-fee u-font-bold">{ currentTaxItem.percent + '%' }</span>
							</Fragment>
						)
					} else if (currentTaxItem.amount) {
						let currentTaxPrice = currentTaxItem.amount

						// FOREX conversion on tax amount
						if (
							yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
							activeCurrencyData &&
							activeCurrencyData.exchangeRate
						) {
							currentTaxPrice = currentTaxItem.amount * activeCurrencyData.exchangeRate
						}

						renderTaxExpenditure = (
							<Fragment>
								<span className="tax-fee u-font-bold">{ rateCurrencySymbol }{ formatRoundPrice(currentTaxPrice, 2) }</span>
								{ rateCurrencyCode && <span className="currency">&nbsp;{rateCurrencyCode}</span> }
							</Fragment>
						)
					}

					taxesFeesList.push(
						<div
							className="bk-flow-room__price-details-accordion-row"
							key={ taxKey }
						>
							<p className="label">
								{ taxDescription }
							</p>

							{ renderTaxExpenditure &&
								<p className="value">
									{ renderTaxExpenditure }
									{ renderTaxFrequency && <span className="frequency">&nbsp;({ renderTaxFrequency })</span>}
								</p>
							}
						</div>
					)
				}
			}
		}
	}
	return (
		taxesFeesList && !_.isEmpty(taxesFeesList) ?
			<div className="bk-flow-room__price-details-accordion-data-group">
				<h6>{ hotelLabels.roomRateTaxesFeesTitle ? hotelLabels.roomRateTaxesFeesTitle : 'Taxes & Fees' }:</h6>
				<div className="bk-flow-room__price-details-accordion-data-content">
					{ taxesFeesList }
				</div>
			</div>
		:
			null
	)
}

const mapStateToProps = state => ({
	urlData: state.availabilityData.urlData,
})

export default connect(mapStateToProps, null)(BkFlowRoomCardTaxesFees)



// WEBPACK FOOTER //
// ./src/components/room/elements/BkFlowRoomCardTaxesFees.js